<template>

    <div class="py-4 px-5">

        <div class="row">
            <div class="col-md-12 text-left">
                
                <p class="py-2">Users of this service agree to be bound to the following terms under the State of Alabama jurisdiction.</p>

                <p class="py-2"><b>Stringers/Video Providers:</b> Posting video to this platform grants Live Storms Media LLC (the company) the exclusive right to license and promote content as the company sees fit, following agreements made individually. By using this platform, you agree to resolve any disagreements with the company that cannot be resolved via personal communication through arbitration by a mutually agreed upon arbiter. Content posted to this platform does not imply a transfer of ownership: the individual(s) or company(s) providing the content will maintain ownership unless otherwise stated in supporting documentation. Content posted and the right to license said content can only be changed at the discretion of the company. Barring other agreements or extenuating circumstance, a submitted request to remove and discontinue licensing content may be granted 30 to 60 days after the request is received. By agreeing to these terms, you also agree to not discuss or inform outside parties of any of the content or property (intellectual or otherwise) that you are allowed to utilize while using this system. Furthermore, anyone providing video is subject to the terms they agreed to when becoming a contractor for the company. If an external agreement between the video provider and the compant  is in conflict with the terms for this platform, those external agreements invalidate the terms herein that are in conflict: All other terms here will remain valid. Failure to agree to these terms may result in a permanent removal from this media distribution system.</p>

                <p class="py-2"><b>Media/Content Consumers:</b> By agreeing to these terms, you (the user) agree to not discuss or inform outside parties of any of the content or property (intellectual or otherwise) that you are allowed to utilize while using this system. Unless otherwise stated, downloading media constitutes purchase at the listed price. To view the content prior to purchase, a watermarked version at a lower quality than the purchasable media is provided free of charge. Utilizing the preview media with or without removing the watermarking in any way other than the intended preview constitutes purchase. Live Storms Media LLC (the company) will consider improper procurement of video in this manner a purchase and will charge an additional fee of 100% of the original video price to the offending party. All purchases unless agreed upon in external documentation are considered 30 day usage, non-exclusive.  Purchasing content does not result in any transfer of ownership nor the right to relicense content. If an external agreement between the user and the company is in conflict with the terms for this platform, those external agreements invalidate the terms herein that are in conflict: All other terms here will remain valid.</p>

            </div>
        </div>
        
        <div class="flex flex-row justify-between mt-4">
             <button class="py-2 px-3 bg-red-700 text-white rounded focus:outline-none" v-on:click="decline">
                <span v-if="!declineLoading">I DO NOT ACCEPT</span>
                <span v-if="declineLoading"><i class="far fa-circle-notch fa-spin"></i></span>
            </button>
            <button class="py-2 px-3 bg-green-700 text-white rounded focus:outline-none" v-on:click="accept">
                <span v-if="!acceptLoading">I ACCEPT</span>
                <span v-if="acceptLoading"><i class="far fa-circle-notch fa-spin"></i></span>
            </button>
        </div>
    </div>

</template>

<script>

    import { EventBus } from '../../utils/events'
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';

	export default {
        name: 'About',
		data () {
			return {
                msg: 'Welcome to Your Vue.js App',
                acceptLoading: false,
                declineLoading: false,
			}
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            accept() {
                this.acceptLoading = true;

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/utilities/terms", { approved: true }, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {

                        _this.acceptLoading = false;

                        // if(_this.$store.state.auth.userInfo.role == "media_producer" || _this.$store.state.auth.userInfo.role == "media_purchaser") {

                        //     var data = {
                        //         at: 'social',
                        //         direction: 'forward',
                        //     }
                        //     EventBus.$emit('account-setup-navigation', data)

                        // } else {

                        //     var data = {
                        //         at: 'terms',
                        //         direction: 'forward',
                        //     }
                        //     EventBus.$emit('account-setup-navigation', data)

                        // }

                        var data = {
                            at: 'social',
                            direction: 'forward',
                        }
                        EventBus.$emit('account-setup-navigation', data)
                    }

                });

                
            },

            decline() {

                this.declineLoading = true;

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/utilities/terms", { approved: false }, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {

                        _this.declineLoading = false;

                        this.$router.push({ name: 'Login'})

                    }

                });

            },

        }
    }

</script>



<style scoped>



</style>
